var map = {
	"./ca-CA.json": [
		8412,
		412
	],
	"./en-GB.json": [
		3708,
		708
	],
	"./es-ES.json": [
		9480,
		480
	],
	"./fr-FR.json": [
		9044,
		44
	],
	"./it-IT.json": [
		5038,
		38
	],
	"./pt-PT.json": [
		5496,
		496
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 2096;
module.exports = webpackAsyncContext;